<template>
    <div id="kt_header" style="" class="header align-items-stretch">
        <!--begin::Container-->
        <div class="container-fluid d-flex align-items-stretch justify-content-between">
            <!--begin::Aside mobile toggle-->
            <div class="d-flex align-items-center d-lg-none ms-n2 me-2" title="Show aside menu">
                <div class="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px" id="kt_aside_mobile_toggle">
                    <!--begin::Svg Icon | path: icons/duotune/abstract/abs015.svg-->
                    <span class="svg-icon svg-icon-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z" fill="black"></path>
                            <path opacity="0.3" d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z" fill="black"></path>
                        </svg>
                    </span>
                    <!--end::Svg Icon-->
                </div>
            </div>
            <!--end::Aside mobile toggle-->
            <!--begin::Mobile logo-->
            <div class="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
                <a href="/" class="d-lg-none">
                    <img alt="Logo" :src="'/admin/images/logo_mostra.png'" class="h-30px">
                </a>
            </div>
            <!--end::Mobile logo-->
            <!--begin::Wrapper-->
            <div class="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
                <!--begin::Navbar-->
                <div class="d-flex align-items-stretch" id="kt_header_nav">
                </div>
                <!--end::Navbar-->
                <!--begin::Toolbar wrapper-->
                <div class="d-flex align-content-end flex-shrink-0">
                    <!--begin::User menu-->
                    <div class="d-flex align-items-center ms-1 ms-lg-3" id="kt_header_user_menu_toggle">
                        <!--begin::Menu wrapper-->
                        <div class="cursor-pointer symbol symbol-55px symbol-md-55px" data-kt-menu-trigger="click" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
                            <i class="bi fs-2hx bi-person-circle"></i>
                        </div>
                        <!--begin::User account menu-->
                        <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px" data-kt-menu="true">
                            <!--begin::Menu item-->
                            <div class="menu-item px-3">
                                <div class="menu-content d-flex align-items-center px-3">
                                    <!--begin::Avatar-->
                                    <div class="symbol symbol-50px me-5">
                                      <i class="bi fs-2hx bi-person-circle"></i>
                                    </div>
                                    <!--end::Avatar-->
                                    <!--begin::Username-->
                                    <div class="d-flex flex-column">
                                        <div class="fw-bolder d-flex align-items-center fs-5">{{ username }} </div>
                                        <a href="#" class="fw-bold text-muted text-hover-primary fs-7">{{ this.$page.props.user.email }}</a>
                                    </div>
                                    <!--end::Username-->
                                </div>
                            </div>
                            <!--end::Menu item-->
                            <!--begin::Menu separator-->
                            <div class="separator my-2"></div>
                            <!--end::Menu separator-->
                            <!--begin::Menu item-->
<!--                            <div class="menu-item px-5">-->
<!--                                <a href="/metronic8/demo1/../demo1/account/overview.html" class="menu-link px-5">My Profile</a>-->
<!--                            </div>-->
<!--                            &lt;!&ndash;end::Menu item&ndash;&gt;-->
<!--                            &lt;!&ndash;begin::Menu item&ndash;&gt;-->
<!--                            <div class="menu-item px-5">-->
<!--                                <a href="/metronic8/demo1/../demo1/apps/projects/list.html" class="menu-link px-5">-->
<!--                                    <span class="menu-text">My Projects</span>-->
<!--                                    <span class="menu-badge">-->
<!--                                        <span class="badge badge-light-danger badge-circle fw-bolder fs-7">3</span>-->
<!--                                    </span>-->
<!--                                </a>-->
<!--                            </div>-->
<!--                            &lt;!&ndash;end::Menu item&ndash;&gt;-->
<!--                            &lt;!&ndash;begin::Menu item&ndash;&gt;-->
<!--                            <div class="menu-item px-5">-->
<!--                                <a href="/metronic8/demo1/../demo1/account/statements.html" class="menu-link px-5">My Statements</a>-->
<!--                            </div>-->
<!--                            &lt;!&ndash;end::Menu item&ndash;&gt;-->
<!--                            &lt;!&ndash;begin::Menu separator&ndash;&gt;-->
<!--                            <div class="separator my-2"></div>-->
<!--                            &lt;!&ndash;end::Menu separator&ndash;&gt;-->
<!--                            &lt;!&ndash;begin::Menu item&ndash;&gt;-->
<!--                            <div class="menu-item px-5 my-1">-->
<!--                                <a href="/metronic8/demo1/../demo1/account/settings.html" class="menu-link px-5">Account Settings</a>-->
<!--                            </div>-->
                            <!--end::Menu item-->
                            <!--begin::Menu item-->
                            <div class="menu-item px-5">
<!--                                <a href="/metronic8/demo1/../demo1/authentication/flows/basic/sign-in.html" class="menu-link px-5">Sign Out</a>-->
                              <Link
                                  :href="this.route('app.usuarios.profile')"
                                  class="menu-link px-5"> Meu Perfil</Link>
                              <Link
                                  :href="this.route('logout')"
                                  method="post"
                                  as="link"
                                  type="button"
                                  class="menu-link px-5"> Sair do sistema
                              </Link>
                            </div>
                            <!--end::Menu item-->
                        </div>
                        <!--end::User account menu-->
                        <!--end::Menu wrapper-->
                    </div>
                    <!--end::User menu-->
                </div>
                <!--end::Toolbar wrapper-->
            </div>
            <!--end::Wrapper-->
        </div>
        <!--end::Container-->
    </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Link,
  },
  computed: {
    username() {
      return this.$page.props.user.name.split(' ')[0]
    }
  }
}
</script>
